import React from "react";

import { i18n } from "../../../translate/i18n";
import { SocialChannelBadge } from "./SocialChannelBadge";
import { resolveMediaUrl } from "../../../helpers/resolveMediaUrl";

export default function PostFeedCard({ group, onOpenComments }) {
	const { post, channel } = group;
	const total = group.commentsTotal ?? group.comments?.length ?? 0;
	const mediaUrl = resolveMediaUrl(post?.thumbnailUrl);

	return (
		<article className="flex flex-col overflow-hidden rounded-2xl border border-default-200 bg-card shadow-sm dark:border-default-700">
			<div className="flex items-center justify-between gap-2 px-3 py-2.5 sm:px-4 sm:py-3">
				<SocialChannelBadge channel={channel} />
				<span className="truncate text-[11px] font-medium text-default-500 sm:text-xs">
					{i18n.t("socialComments.commentsCount", { count: total })}
				</span>
			</div>

			<button
				type="button"
				className="group relative block w-full overflow-hidden bg-black"
				onClick={() => onOpenComments?.(group)}
				aria-label={i18n.t("socialComments.viewComments")}
			>
				{mediaUrl ? (
					<img
						src={mediaUrl}
						alt={post?.caption || ""}
						className="aspect-square w-full object-cover transition duration-300 group-hover:scale-[1.02]"
					/>
				) : (
					<div className="flex aspect-square w-full items-center justify-center bg-default-100 text-sm text-default-500 dark:bg-default-800">
						Sem imagem
					</div>
				)}
				<div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-black/0 opacity-0 transition group-hover:bg-black/25 group-hover:opacity-100">
					<span className="rounded-full bg-black/55 px-4 py-2 text-sm font-semibold text-white backdrop-blur-sm">
						{i18n.t("socialComments.viewComments")}
					</span>
				</div>
			</button>

			<div className="flex flex-1 flex-col gap-2 px-3 py-3 sm:gap-3 sm:px-4 sm:py-4">
				{post?.caption ? (
					<p className="line-clamp-2 text-sm text-default-700 sm:line-clamp-3 dark:text-default-200">
						{post.caption}
					</p>
				) : (
					<p className="text-sm text-default-500">Sem descrição</p>
				)}

				<button
					type="button"
					className="btn btn-primary btn-sm mt-auto w-full"
					onClick={() => onOpenComments?.(group)}
				>
					{i18n.t("socialComments.viewComments")}
				</button>
			</div>
		</article>
	);
}
